import React from "react";
import FormControlMui, { FormControlProps } from "@mui/material/FormControl";

export type Props = FormControlProps;

export function FormControl({ children, ...props }: Props) {
  return <FormControlMui {...props}>{children}</FormControlMui>;
}
